import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Opens a stock report over the current page instead of replacing it.
 *
 * The route still changes to /stock/SYMBOL so the URL is shareable, but the
 * page underneath is remembered in history state and keeps rendering. Without
 * this, opening a stock from the swing page unmounted it, and closing landed
 * you on the screener with your results and scroll position gone.
 */
export function useOpenStock(holdingYears = 3) {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(
    (symbol, strategy) => {
      if (!symbol) return;
      navigate(`/stock/${encodeURIComponent(symbol)}`, {
        state: {
          background: location.state?.background ?? location,
          holdingYears,
          // Which page opened this, so the chart marks that strategy's trades
          // rather than every strategy's at once.
          strategy: strategy ?? location.state?.strategy ?? null
        }
      });
    },
    [navigate, location, holdingYears]
  );
}

/** Closes the report, returning to the page it opened over. */
export function useCloseStock() {
  const navigate = useNavigate();
  const location = useLocation();
  const background = location.state?.background;

  return useCallback(() => {
    if (background) navigate(-1);
    else navigate('/stocks');
  }, [navigate, background]);
}
